import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentForFirstResponders from "@/pages/DepressionTreatmentForFirstResponders";
export const Route = createFileRoute(
  "/depression-treatment-for-first-responders",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Depression Treatment For First Responders | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "First responders face unique mental health risks. Learn about TMS, SAINT TMS, and depression treatment options for first responders in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Depression Treatment For First Responders | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "First responders face unique mental health risks. Learn about TMS, SAINT TMS, and depression treatment options for first responders in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-for-first-responders",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-for-first-responders",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentForFirstResponders />;
}
